// extracted by mini-css-extract-plugin
export default {"navBtns":"Wrapper_navBtns__JDLsP","next":"Wrapper_next__lHxY7","previous":"Wrapper_previous__FvN8A"};